import { useState, useEffect } from 'react';
import { useMsal } from "@azure/msal-react";
import { rulesApiRequest } from "../config/msalConfig";
import { useLocalStorage } from 'usehooks-ts';
import appConfig from '../config/appConfig';
import axios from 'axios';

const PROFILE_IMAGE = 'PROFILE_IMAGE';
const PROFILE_IMAGE_DATA = 'PROFILE_IMAGE_DATA';

const axiosInstance = axios.create({
  baseURL: appConfig.apiUrl
});

function truncateEmail(email, maxLength) {
  if (!email) return '';
  return email.length > maxLength ? email.substring(0, maxLength) + '...' : email;
}

const useProfileData = (fetchProfileImage = true) => {
  const [token, setToken] = useState();
  const [profileImage, setProfileImage] = useLocalStorage(PROFILE_IMAGE, '');
  const [profileImageData, setProfileImageData] = useLocalStorage(PROFILE_IMAGE_DATA, null);
  const [userName, setUserName] = useState();
  const [userEmail, setUserEmail] = useState();
  const { instance, accounts } = useMsal();
  const firstAccount = accounts && accounts[0];

  useEffect(() => {
    const fetchProfileData = async () => {
      if (!firstAccount) return;

      try {
        // Get token for your API
        const apiResponse = await instance.acquireTokenSilent({
          ...rulesApiRequest,
          account: firstAccount
        });

        axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${apiResponse.accessToken}`;
        setToken(apiResponse.accessToken);
        setUserName(apiResponse.account.name);
        setUserEmail(truncateEmail(apiResponse.account.username, 50));
      } catch (error) {
        console.error('Error fetching API token:', error);
      }
    };

    fetchProfileData();
  }, [instance, firstAccount]);


  useEffect(() => {
    const fetchProfileImage = async () => {
      if (accounts.length > 0) {
        try {
          const response = await instance.acquireTokenSilent({
            account: accounts[0],
            scopes: ["User.Read"]
          });

          const graphResponse = await axios.get("https://graph.microsoft.com/v1.0/me/photo/$value", {
            headers: {
              Authorization: `Bearer ${response.accessToken}`
            },
            responseType: "blob" // important!
          });

          // Convert blob to image URL
          const imageBlob = graphResponse.data;
          const imageObjectURL = URL.createObjectURL(imageBlob);
          setProfileImage(imageObjectURL);
        } catch (error) {
          console.error("Error fetching profile image:", error);
        }
      }
    };

    fetchProfileImage();
  }, [accounts, instance]);

  return { token, profileImage, userName, userEmail, profileImageData };
};

export default useProfileData;